import React, { Component } from 'react';
import LoaderElement from './icons/loaderElement';
import COLORS from '../../../common/colors';

export default class NoSSR extends Component {
  state = {
  	mounted: false,
  }

  componentDidMount() {
    this.setState({ mounted: true })
  }

  render() {
    return this.state.mounted ? this.props.children : <LoaderElement color={`${COLORS.giveDarkGrey}`} size="20" style={{ paddingRight: '5px' }} />
  }
}
